import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pt-add-notes-dialog',
  standalone: true,
  template: `
    <div class='modal-header'>
      <h4 class='modal-title'>
        {{ title | async }}</h4>
    </div>

    <div class='modal-body'>
      <form [formGroup]='formGroup'>
        <textarea
          [rows]='25'
          autocomplete='off'
          formControlName='notes'
          class='form-control form-control-sm'
          aria-describedby='ptWInputHelp' style="height: auto">
        </textarea>
      </form>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-primary btn-sm'
              [disabled]='formGroup?.invalid'
              (click)='confirm(); $event.stopPropagation()'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </button>
      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `,
  imports: [
    AsyncPipe,
    ReactiveFormsModule,
    TranslateModule
  ]
})
export class AddNotesDialogComponent {
  title!: Observable<string>;
  notes?: string;

  public formGroup: FormGroup = new FormGroup({
    notes: new FormControl(this.notes ? this.notes : null)
  });

  constructor(public activeModal: NgbActiveModal) {
  }

  run(title: Observable<string> , notes?: string) {
    this.title = title;
    this.notes = notes;
    this.formGroup.controls['notes'].setValue(notes);
  }

  confirm() {
    const form = this.formGroup.getRawValue();
    if (form) {
      this.activeModal.close(form);
    } else {
      this.activeModal.close(false);
    }
  }
}
